import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { buttonBaseStyles } from "@store/theme/mixins";
import { css } from "styled-components";

Object.assign(customerSelectorToolbarStyles, {
    ...customerSelectorToolbarStyles,
    wideCreateNewAddressButton: {
        variant: "tertiary",
        css: css`
            ${buttonBaseStyles("outline")}
            margin-left: 10px;
            min-height: 48px; // Fits with toolbar height
        `,
    },
});
